import React from 'react';
import i18n from 'i18next';
import styles from './imageCreativeHint.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import config from 'config';

export const ImageCreativeHint: React.FunctionComponent<{
  sizeList?: { width: number, height: number }[],
  customStyles?: any,
  closeHint: () => void
}> = ({
  sizeList = [{ width: 960, height: 320 }, { width: 1000, height: 60 }],
  customStyles = styles,
  closeHint
}) => {

  const renderRecommendSize = () => {
    return sizeList.map((size) => (
      <div key={`${size.width} x ${size.height}`} className={customStyles[`size${size.width}x${size.height}`]}>
        {`${size.width} x ${size.height}`}
      </div>
    ));
  };

  return (
    <div className={styles.imageCreativeHint}>
      <div className={styles.title}>
        <span>{i18n.t<string>('imageCreativeHint.labels.creativeInfoHint')}</span>
        <FontAwesomeIcon icon={faTimes} onClick={closeHint}/>
      </div>
      <div className={styles.recommendSize}>
        <div className={styles.subTitle}>
          <span>{i18n.t<string>('imageCreativeHint.labels.sizeInstruction')}</span>
        </div>
        <div className={customStyles.recommendSizeContent}>
          {renderRecommendSize()}
        </div>
      </div>
      <div className={styles.creativePolicy}>
        <div className={styles.subTitle}>
          <span>{i18n.t<string>('imageCreativeHint.labels.creativePolicy')}</span>
        </div>
        <div className={styles.creativePolicyContent}>
          <a href={`${config.url}/creative-policy`} target='_blank' rel='noreferrer'>
            {i18n.t<string>('creativePolicy.titles.creativePolicy')}
          </a>
        </div>
      </div>
    </div>
  );
};
